export default __webpack_public_path__ + "static/media/SmileRed.502fddf9.svg";